import { STORE_ID, TYPES } from "./types"

const INITIAL_STATE = {
    item: {
        descricao: "",
        bancoId: "0",
        operacaoRcId: "0",
        id: ""
    },
    copy: {},
    invalid: {
        descricao: false,
        bancoId: false,
        operacaoRcId: false
    },
    items: [],
    bancos: [],
    operacoesRc: [],
    activeTab: "Search",
    seeRegister: false,
    permitions: {
        criar: false,
        deletar: false,
        autorizar: false,
    }
}

export default function operacaoInstituicao(state = INITIAL_STATE, action) {
    switch (action.storeId) {
        case STORE_ID:
            switch (action.type) {
                case TYPES.SET_PERMITIONS:
                    return { ...state, permitions: action.value }
                case TYPES.OPERACOES_INSTITUICOES:
                    return { ...state, items: action.value }
                case TYPES.SET_BANCOS:
                    return { ...state, bancos: action.value }
                case TYPES.SET_OPERACOESRC:
                    return { ...state, operacoesRc: action.value }
                case TYPES.OPERACAO_INSTITUICAO:
                    return { ...state, item: action.value }
                case TYPES.INVALID_OPERACAO_INSTITUICAO:
                    return { ...state, invalid: { ...state.invalid, [action.field]: true } }
                case TYPES.CLEAN_INVALID_OPERACAO_INSTITUICAO:
                    return { ...state, invalid: { ...state.invalid, [action.field]: false } }
                case TYPES.OPERACAO_INSTITUICAO_COPY:
                    return { ...state, copy: action.value }
                case TYPES.CLEAN_REGISTER:
                    return { ...state, item: INITIAL_STATE.item, invalid: INITIAL_STATE.invalid }
                case TYPES.SET_ACTIVE_TAB:
                    return { ...state, activeTab: action.value }
                case TYPES.SET_SEE:
                    return { ...state, seeRegister: action.value }
                default:
                    return { ...state }
            }
        default:
            return { ...state }
    }
}